import { useEffect } from 'react';
import TechDocsLogo from '../../assets/techdocs-puzzle-logo.svg';
import { Header, HeaderLabel } from '@backstage/core-components';
import { useTechDocsReaderPage } from '@backstage/plugin-techdocs-react';
import {
  TechDocsReaderPageSubheader,
  TechDocsReaderPageContent,
  TechDocsReaderPage,
  techdocsPlugin,
} from '@backstage/plugin-techdocs';
import { attachComponentData } from '@backstage/core-plugin-api';
import {
  getEntityRelations,
  EntityRefLink,
  EntityRefLinks,
} from '@backstage/plugin-catalog-react';
import { RELATION_OWNED_BY } from '@backstage/catalog-model';
import Skeleton from '@material-ui/lab/Skeleton';

const CustomTechDocsReaderHeader = () => {
  const {
    title,
    setTitle,
    setSubtitle,
    entityRef,
    metadata: { value: metadata },
    entityMetadata: { value: entityMetadata },
  } = useTechDocsReaderPage();

  useEffect(() => {
    if (!metadata) return;
    setTitle(metadata.site_name);
    setSubtitle(() => {
      let desc = metadata.site_description;
      if (!desc || desc === 'None') desc = '';
      return desc;
    });
  }, [metadata, setTitle, setSubtitle]);

  const { spec } = entityMetadata || {};
  const lifecycle = spec?.lifecycle;
  const ownedByRelations = entityMetadata
    ? getEntityRelations(entityMetadata, RELATION_OWNED_BY)
    : [];

  const skeleton = (
    <Skeleton animation="wave" variant="text" style={{ height: 40 }} />
  );

  const entityKind = entityMetadata?.kind || 'entity';

  return (
    <Header
      title={
        <img
          src={TechDocsLogo}
          alt="Puzzle Tech Docs"
          style={{ height: '40px', width: 'auto' }}
        />
      }
      pageTitleOverride="Puzzle Tech Docs"
      subtitle={<>{title || skeleton}</>}
    >
      <HeaderLabel
        label={entityKind.charAt(0).toUpperCase() + entityKind.slice(1)}
        value={
          <EntityRefLink
            color="inherit"
            entityRef={entityRef}
            title={entityMetadata?.metadata?.title}
            defaultKind="Component"
          />
        }
      />
      {ownedByRelations.length > 0 && (
        <HeaderLabel
          label="Owner"
          value={
            <EntityRefLinks
              color="inherit"
              entityRefs={ownedByRelations}
              defaultKind="group"
            />
          }
        />
      )}
      {lifecycle && <HeaderLabel label="Lifecycle" value={String(lifecycle)} />}
    </Header>
  );
};

export const CustomTechDocsReaderPage = (props: any) => (
  <TechDocsReaderPage {...props}>
    {() => (
      <>
        <CustomTechDocsReaderHeader />
        <TechDocsReaderPageSubheader />
        <TechDocsReaderPageContent withSearch />
      </>
    )}
  </TechDocsReaderPage>
);

attachComponentData(
  CustomTechDocsReaderPage,
  'core.mountPoint',
  techdocsPlugin.routes.docRoot,
);
